import SelectBranchConfirmationDialog from "@/components/OrderTrackingTable/SelectBranch/selectBranchConfirmationDialog.component";
import { AppContext } from "@/services/AppContext/appContext";
import { Label } from "@/shadcn/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/shadcn/components/ui/select";
import { OrderBranches } from "@/types";
import React, { useContext, useState } from "react";

type SelectBranchProps = {
  orderID: string;
  currentBranchID: string;
  setCurrentBranchID: (branchID: string) => void;
  branches: OrderBranches[];
};

const SelectBranch: React.FC<SelectBranchProps> = ({
  orderID,
  currentBranchID,
  setCurrentBranchID,
  branches,
}) => {
  const { userRole } = useContext(AppContext);
  const [submitting, setSubmitting] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState<string | false>(
    false
  );

  return (
    (userRole === "admin" || userRole === "super_admin") && (
      <>
        <div className="mb-4 ml-2 flex items-center">
          <div className="space-y-2">
            <Label>
              Branch
              <Select
                value={currentBranchID}
                onValueChange={setShowConfirmation}
                disabled={submitting}
              >
                <SelectTrigger className="max-w-52 min-w-32 truncate capitalize">
                  <SelectValue placeholder="Filter by Status" />
                </SelectTrigger>
                <SelectContent>
                  {branches.map((branch) => (
                    <SelectItem key={branch.id} value={branch.id}>
                      {branch.name}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </Label>
          </div>
        </div>
        {showConfirmation && (
          <SelectBranchConfirmationDialog
            onClose={() => setShowConfirmation(false)}
            onConfirm={(branchID) => {
              setCurrentBranchID(branchID);
              setShowConfirmation(false);
            }}
            newBranchID={showConfirmation}
            orderID={orderID}
            newBranchName={
              branches.find((branch) => branch.id === showConfirmation)?.name ||
              ""
            }
          />
        )}
      </>
    )
  );
};

export default SelectBranch;
